var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrushEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3571 2.9554C15.2021 5.8354 12.3071 9.7504 9.88465 11.6929L8.40715 12.8779C8.21965 13.0129 8.03215 13.1329 7.82215 13.2154C7.82215 13.0804 7.81465 12.9304 7.79215 12.7879C7.70965 12.1579 7.42465 11.5729 6.92215 11.0704C6.41215 10.5604 5.78965 10.2604 5.15215 10.1779C5.00215 10.1704 4.85215 10.1554 4.70215 10.1704C4.78465 9.9379 4.91215 9.7204 5.06965 9.5404L6.23965 8.0629C8.17465 5.6404 12.1046 2.7304 14.9771 1.5829C15.4196 1.4179 15.8471 1.5379 16.1171 1.8154C16.4021 2.0929 16.5371 2.5204 16.3571 2.9554Z",
    stroke: "#99A4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82295 13.2151C7.82295 14.0401 7.50795 14.8276 6.91545 15.4276C6.45795 15.8851 5.83545 16.2001 5.09295 16.2976L3.24795 16.5001C2.24295 16.6126 1.38045 15.7576 1.50045 14.7376L1.70295 12.8926C1.88295 11.2501 3.25545 10.2001 4.71045 10.1701C4.86045 10.1626 5.01795 10.1701 5.16045 10.1776C5.79795 10.2601 6.42045 10.5526 6.93045 11.0701C7.43295 11.5726 7.71795 12.1576 7.80045 12.7876C7.80795 12.9301 7.82295 13.0726 7.82295 13.2151Z",
    stroke: "#99A4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6803 10.8522C10.6803 8.89469 9.09031 7.30469 7.13281 7.30469",
    stroke: "#99A4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushEdit);
export default __webpack_public_path__ + "static/media/brushEdit.e032bbfca78b1bdc714152e776753bb6.svg";
export { ForwardRef as ReactComponent };